import { render, staticRenderFns } from "./barcodeController.vue?vue&type=template&id=10faad29&"
import script from "./barcodeController.vue?vue&type=script&lang=ts&"
export * from "./barcodeController.vue?vue&type=script&lang=ts&"
import style0 from "./barcodeController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports